import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledLoadingContainer = styled(Box)(() => ({
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: 2,
}));
export const StyledTextError = styled(Box)(() => ({
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  px: 2,
}));
